/**
 * Create an RTCPeerConnection with constraints if passed.
 * SRV-1584: Necessary because typescript doesn't support an second parameter.
 *
 * @returns {RTCPeerConnection} a new RTCPeerConnection instances.
 */
export default function makeRTCPeerConnection(configuration, constraints) {
  if (constraints) {
    return new RTCPeerConnection(configuration, constraints);
  }
  return new RTCPeerConnection(configuration);
}
